import React, { Fragment, useState } from "react";
import ModalComponent from "@/components/modal";
import { Col, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentForm,
  setFormProps,
  setIsLoggedIn,
  setModalOpen,
} from "@/reducers/commonSlice";
import ButtonComponent from "@/components/button/Button";

import "@/styles/pages/auth/journey-card.scss";
import { updateStage } from "@/services/users/updateStage";
import { useNavigate } from "react-router-dom";
import {
  getIsCheckoutToShow,
  getIsProductRegisterSuccessToShow,
  getRegisterProdutId,
  setIsProductRegisterSuccessToShow,
} from "@/reducers/checkoutSlice";
import { registerProducts } from "@/services/services/registerProducts";
import { setIsGuidePanel } from "@/reducers/guideSlice";

const JourneySelection = ({ isOpen = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isCheckoutToShow = useSelector(getIsCheckoutToShow);
  const isProductRegisterSuccessToShow = useSelector(getIsProductRegisterSuccessToShow);
  const registerProductId = useSelector(getRegisterProdutId);

  const [selectedJourney, setSelectedJoureny] = useState(
    localStorage.getItem("stage") ?? "PreApplication"
  );
  const handleContinue = () => {
    updateStage({
      stage: selectedJourney,
    })
      .then((response) => {
        localStorage.setItem("stage", selectedJourney);
        console.log(response);

        if (selectedJourney !== "GotAdmission" && selectedJourney !== "AlreadyAtUniversity") {
          dispatch(setCurrentForm("setPrefrences"));
        } else {
          if (isProductRegisterSuccessToShow && registerProductId) {
            registerProducts({
              productId: registerProductId,
            })
              .then((res) => {
                dispatch(setCurrentForm("productSuccess"));
                dispatch(setModalOpen(true));
                dispatch(
                  setFormProps({
                    message: "Your interest was registered",
                    subMessage: "Team will contact you shortly",
                    onSubmit: () => {
                      dispatch(setModalOpen(false));
                      dispatch(setIsProductRegisterSuccessToShow(false));
                    },
                  })
                );
              })
              .catch((err) => console.log(err));
          }

          dispatch(setIsLoggedIn(true));
          dispatch(setIsGuidePanel(false));
          dispatch(setModalOpen(false));

          if (isCheckoutToShow) {
            navigate("/checkout-preview");
          }
        }
      })
      .catch((error) => console.log(error));
  };

  const data = [
    {
      label: "Planning to Apply Abroad",
      subLabel:
        "You need guidance in selecting the right university and country for your studies abroad. If you have a dream university or country in mind, you can connect with a current student there to help with your application process.",
      value: "PreApplication",
    },
    {
      label: "Already Applied Abroad",
      subLabel:
        "You have submitted applications to universities abroad and are looking for support with scholarships, visa applications, loans, and other essential services.",
      value: "AlreadyApplied",
    },
    {
      label: "Ready To Fly Abroad",
      subLabel:
        "You have completed all pre-departure formalities and are preparing for life in a new country. Get guidance on accommodation, tuition fee remittance, and other important aspects of settling in.",
      value: "GotAdmission",
    },
    {
      label: "Already at University Abroad",
      subLabel:
        "You are currently studying abroad and seeking support with academics, job opportunities, internships, and other aspects of student life.",
      value: "AlreadyAtUniversity",
    },
  ];
  return (
    <Fragment>
      <ModalComponent
        buttonLabel="Create Account"
        isOpen={isOpen}
        width={1257}
        maskClosable={false}
        className="onboarding-modal"
      >
        <div className="create-account-modal">
          <div className="card">
            <Row style={{ justifyContent: "space-between" }}>
              <Col xs={24} md={12}>
                <div className="title-h6-1 heading">
                  To better support you in your study-abroad journey, we need to understand where
                  you currently stand in the process.
                </div>
                <div className="journey-card-wrapper">
                  {data.map((item) => {
                    return (
                      <div
                        key={item.value}
                        className={`journey-card ${
                          selectedJourney === item.value ? "journey-card-selected" : ""
                        }`}
                        onClick={() => setSelectedJoureny(item.value)}
                      >
                        <div className="label">{item.label}</div>
                        <div className="sublabel">{item.subLabel}</div>
                      </div>
                    );
                  })}
                </div>
                <ButtonComponent
                  label="Continue"
                  varient="primary"
                  className="w-100 button-margin"
                  onClick={handleContinue}
                />
              </Col>

              <Col xs={0} md={11} className="image-col">
                <div className="image-container">
                  <img src="/assets/images/signup.svg" alt="College" className="responsive-image" />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default JourneySelection;
